export const categories = [
  "Productivity",
  "File Management",
  "Developer Tools",
  "Collaboration",
  "Ecommerce",
  "Finance Management",
  "Sales",
  "HR Management",
  "Communication",
];

export const SYNC_HISTORY_STATUS = [
  { id: "failed", name: "Failed" },
  { id: "partial", name: "Partial Success" },
  { id: "success", name: "Success" },
];

export const EXETERNAL_SYSTEM_CHOICES = [
  { id: "xero", name: "Xero" },
  { id: "shopify", name: "Shopify" },
  { id: "inventory_planner", name: "Inventory Planner" },
  { id: "shiphero", name: "Ship Hero" },
  { id: "mint_soft", name: "Mint Soft" },
];
